import Vue from "vue";
import { pound } from "../constants/defaultCurrency";
Vue.filter("formatCurrencyDonorbox", function(value) {
  if (value === undefined) value = 0;
  const amount = (value / 100).toFixed(2);
  return pound.symbol + amount;
});
